//Constants
import * as ACTIONS from './actionTypes';

//Types
import { PublishResult } from './types';
import { ActionPublishAPISuccess } from './actions';

export interface ModelSyncState {
    publishResult?: PublishResult
}

const defaultState: ModelSyncState = {

};

type PublishAction = ActionPublishAPISuccess;

function publishReducer(state: ModelSyncState = defaultState, action: PublishAction): ModelSyncState {
    switch (action.type) {
        case ACTIONS.PUBLISH_API_SUCCESS:
            {
                return {
                    ...state,
                    publishResult: action.result
                }
            }
        case ACTIONS.PUBLISH_CLEAN_RESULT:
            {
                return {
                    ...state,
                    publishResult: undefined
                }
            }
    }
    return {
        ...state
    }
}



export default publishReducer;